"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPresenter = void 0;
const debug_1 = require("./debug");
const LoaderUtil_1 = require("./core/LoaderUtil");
const RenderUtil_1 = require("./core/RenderUtil");
const LoaderUtil_2 = require("./product/LoaderUtil");
const RenderUtil_2 = require("./product/RenderUtil");
function createPresenter(assetCache) {
    function renderDebug(canvas, renderSpecification) {
        (0, debug_1.drawDebug)(canvas, renderSpecification);
        return true;
    }
    async function renderProof(canvas, renderSpecification) {
        const context = canvas.getContext('2d');
        if (!context) {
            console.warn('Failed to retrieve context');
            return false;
        }
        await (0, LoaderUtil_1.loadAssets)(renderSpecification, assetCache).loadPromise;
        (0, RenderUtil_1.drawContents)(context, renderSpecification, assetCache);
        return true;
    }
    function renderProofSync(canvas, renderSpecification) {
        const context = canvas.getContext('2d');
        if (!context) {
            return { loaded: false };
        }
        const coreLoaded = (0, LoaderUtil_1.loadAssets)(renderSpecification, assetCache).loaded;
        (0, RenderUtil_1.drawContents)(context, renderSpecification, assetCache);
        return { loaded: coreLoaded };
    }
    async function renderProduct(canvas, renderSpecification) {
        const context = canvas.getContext('2d');
        if (!context) {
            console.warn('Failed to retrieve context');
            return false;
        }
        await Promise.all([
            (0, LoaderUtil_1.loadAssets)(renderSpecification, assetCache).loadPromise,
            (0, LoaderUtil_2.loadAssets)(renderSpecification, assetCache).loadPromise,
        ]);
        (0, RenderUtil_1.drawContents)(context, renderSpecification, assetCache);
        (0, RenderUtil_2.drawProductMask)(context, renderSpecification, assetCache);
        return true;
    }
    function renderProductSync(canvas, renderSpecification) {
        const context = canvas.getContext('2d');
        if (!context) {
            return { loaded: false };
        }
        const coreLoaded = (0, LoaderUtil_1.loadAssets)(renderSpecification, assetCache).loaded;
        const productLoaded = (0, LoaderUtil_2.loadAssets)(renderSpecification, assetCache).loaded;
        (0, RenderUtil_1.drawContents)(context, renderSpecification, assetCache);
        (0, RenderUtil_2.drawProductMask)(context, renderSpecification, assetCache);
        return { loaded: coreLoaded && productLoaded };
    }
    return Object.freeze({
        assetCache,
        renderDebug,
        renderProof,
        renderProofSync,
        renderProduct,
        renderProductSync,
    });
}
exports.createPresenter = createPresenter;
